import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A station post insulator: a fat brown porcelain column of stacked sheds on a
// galvanised base flange, capped by a line-terminal fitting. The ceramic that
// holds a live busbar clear of its steelwork.
const PORC = "#7a4a3a";
const SHED = "#8a5644";
const FLANGE = "#878e96";
const CAP = "#6c727a";

export const insulatorStack = defineModel({
  id: "insulator-stack",
  batchId: "electric",
  name: "Insulator stack",
  tags: ["prop", "electric", "power", "grid", "insulator", "ceramic"],
  summary: "A brown porcelain post insulator with stacked sheds.",
  footprint: 0.2,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.CylinderGeometry(0.13, 0.15, 0.06, 12), color: FLANGE, position: [0, 0.03, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.075, 0.62, 12), color: PORC, position: [0, 0.37, 0] },
    ];
    // Wide ribbed sheds down the column.
    for (let i = 0; i < 6; i++) {
      const r = 0.12 - i * 0.004;
      parts.push({ geometry: new THREE.CylinderGeometry(r, r, 0.03, 12), color: SHED, position: [0, 0.12 + i * 0.1, 0] });
    }
    // Cap fitting and terminal.
    parts.push({ geometry: new THREE.CylinderGeometry(0.085, 0.085, 0.05, 12), color: CAP, position: [0, 0.7, 0] });
    parts.push({ geometry: new THREE.BoxGeometry(0.07, 0.05, 0.07), color: CAP, position: [0, 0.75, 0] });
    return parts;
  },
  animations: [],
});
